import { createContext } from 'react'

export type WebAppContextType = {
    WebApp?: WebApp
}

export const WebAppContext = createContext<WebAppContextType>({})
